import { RootState } from '../../store';

const getWaterSystemGeoBlocksData = (state: RootState) => state.waterSystemGeoBlocks.data;
const selectWaterSystemGeoBlocks = (state: RootState) => state.waterSystemGeoBlocks.data.items;
const selectGeoBlock = (state: RootState) => state.waterSystemGeoBlocks.selectedGeoBlock;

const error = (state: RootState) => state.waterSystemGeoBlocks.error;
const loading = (state: RootState) => state.waterSystemGeoBlocks.loading;
const success = (state: RootState) => state.waterSystemGeoBlocks.success;

export const WaterSystemGeoBlocksSelector = {
    getWaterSystemGeoBlocksData,
    selectWaterSystemGeoBlocks,
    selectGeoBlock,
    error,
    loading,
    success,
};